import EventPhaseEventTime from "app/components/EventPhaseEventTime/EventPhaseEventTime";
import { MomentTime } from "app/components/Moment/Moment";
import { EventHelper } from "app/helpers/eventHelper";
import { ScreenType } from "app/utils/const";
import React from "react";
import "./CountDownDuration.scss";
//
export const CountDownDuration = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> => {
  // TODO  need to cater for other event states when have more data
  const { eventData } = props;
  const eventIncidents = eventData["eventIncidents"];
  const isEventLive = EventHelper.isEventLive(eventData);
  // BET-1841 check if markets contain period of extra time
  const isEventInExtraTime = EventHelper.isEventInExtraTime(eventData);
  const isBeforeExtra = EventHelper.isBeforeExtraTime(eventData);
  const eventTime =
    eventIncidents && isEventLive ? (
      <div className="asian-popular-event-cell__event-time">
        <EventPhaseEventTime
          eventData={eventData}
          eventIncidents={eventIncidents}
          isBeforeExtra={isBeforeExtra}
          isEventInExtraTime={isEventInExtraTime}
          screenType={ScreenType.EUROPEAN}
        />
      </div>
    ) : (
      <MomentTime value={eventData["startTime"]} countDown />
    );
  return (
    <div className="asian-event__time-section">
      <BottomSection eventData={eventData} eventTime={eventTime} />
    </div>
  );
};
export default CountDownDuration;

const BottomSection = (props: Record<string, any>) => {
  // shows starting time
  //  OR if game is live shows time elapsed
  const { eventTime } = props;
  return <div className="asian-event__time-section--bottom">{eventTime}</div>;
};
